<template>
  <section class="section1 slider">
    <div
      v-swiper:mySwiper="swiperOption"
      @slideChangeTransitionEnd="slideChange"
      ref="mySwiper"
    >
      <div class="swiper-wrapper">
        <div
          class="swiper-slide"
          v-for="match in match_data"
          v-bind:key="match.id"
        >
          <div class="match-details">
            <div class="match-name">
              <span class="match-category">
                {{ match.event_name }}
              </span>
              <div class="teams">
                <span class="team1">
                  {{ getTeamSN('t1', match) }}
                </span>
                <span class="versus">{{translations.vs_label}}</span>
                <span class="team2">
                  {{ getTeamSN('t2', match) }}
                </span>
              </div>
            </div>
            <div class="match-time">
              <span class="match-category">{{match.upcoming_in.custom_date}}</span>
              <div class="teams">
                <span class="versus">{{match.upcoming_in.custom_time}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <a
        class="slider-nav swiper-button-prev"
        :href="matchByIndexOffset(-1)"
        slot="button-prev"
      ></a>
      <a
        class="slider-nav swiper-button-next"
        :href="matchByIndexOffset(1)"
        slot="button-next"
      ></a>
    </div>
  </section>
</template>
<script>
import Vue from "vue";
import { formatFullUrl, getMatch } from "../../../assets/js/common";
import { Swiper as SwiperClass, Pagination, Navigation } from "swiper";
import getAwesomeSwiper from "vue-awesome-swiper/dist/exporter";

if (process.browser) {
    SwiperClass.use([Pagination, Navigation]);
    Vue.use(getAwesomeSwiper(SwiperClass));
}

export default {
  name: "carousel",
  props: ["parentRoute", "loaded_module", "componentSlideChnageHandler"],
  components: {
  },
  computed: {
    match_data() {
      return (
        this.$store.state.match_detail_store.match_data[this.$store.state.match_detail_store.current_category] || []
      );
    },
    translations() {
      return this.$store.state.translations;
    },
  },
  data() {
    return {
      swiperOption: {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    };
  },
  methods: {
    matchByIndexOffset(index_offset) {
      let slug = this.$store.state.slug;
      let currentMatchIndex = getMatch(this.match_data, "slug", slug, true);
      let match = this.match_data.find((match, index) => {
        return index === currentMatchIndex + index_offset;
      });

      if (typeof match !== "undefined") {
        let url_slug = formatFullUrl(match, this.parentRoute);
        return url_slug;
      }
    },
    getTeamSN(type, match) {
      let { teams, are_teams_reversed } = match;
      let t1Idx = teams[1].is_home_team ? 1 : 0,
          t2Idx = teams[1].is_home_team ? 0 : 1;
      if(are_teams_reversed) {
        let temp = t1Idx;
        t1Idx = t2Idx, t2Idx = temp;
      }
      
      let idx = (type == "t2") ? t2Idx : t1Idx;
      
      return (teams[idx].team_updated_short_name || teams[idx].short_name);
    },
    getMatch() {
      return this.match_data.find((match, index) => {
        return index === this.$refs.mySwiper.swiper.activeIndex;
      });
    },
    slideChange() {
      let currentMatch = this.getMatch();
      let matchUrl = formatFullUrl(currentMatch, this.parentRoute);
      window.location.href = matchUrl;
    },
  },
  beforeDestroy() {
  },
};
</script>
